import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.use({
  gfm: true,
  breaks: true
});

export default function Markdown({ content, className = '' }) {
  if (!content) return null;

  const raw = marked.parse(content);
  const withTargets = raw.replace(/<a\s/g, '<a target="_blank" rel="noopener noreferrer" ');
  const sanitized = DOMPurify.sanitize(withTargets, { ADD_ATTR: ['target', 'rel'] });

  return (
    <div 
      className={`prose ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitized }}
      style={{
        lineHeight: 1.8,
        color: 'var(--text-mid)'
      }}
    />
  );
}
